// Generated by Melange

import * as ReactRouter from "@tanstack/react-router";
import * as Caml_option from "melange.js/caml_option.jsx";
import * as Fx from "../fx/fx.jsx";
import * as Pages__AlbumPage from "../pages/albumPage.jsx";
import * as $$Promise from "../promise/promise.jsx";
import * as Routes__LayoutRoute from "./layoutRoute.jsx";
import * as Shared__CoverArt from "../shared/coverArt.jsx";
import * as Shared__MediaHeader from "../shared/mediaHeader.jsx";
import * as Shared__RouterUtils from "../shared/routerUtils.jsx";
import * as Stdlib__Fun from "melange/fun.jsx";
import * as Stdlib__Option from "melange/option.jsx";
import * as Stdlib__Result from "melange/result.jsx";
import * as StoreFx__FetchAlbumInfo from "../storeFx/fetchAlbumInfo.jsx";
import * as StoreFx__FetchOneAlbum from "../storeFx/fetchOneAlbum.jsx";
import * as JsxRuntime from "react/jsx-runtime";

function loader(param) {
  const albumId = param.params.albumId;
  const store = param.context.store;
  const state = store.getState();
  const credentials = Stdlib__Option.get(state.auth.credentials);
  const albumPromise = Fx.runAsync(StoreFx__FetchOneAlbum.make(albumId), {
    store: store
  }).then(function (result) {
    return Promise.resolve(Stdlib__Result.get_ok(result));
  });
  const basePromise = albumPromise.then(function (param) {
    const state = store.getState();
    return Promise.resolve(Stdlib__Option.get(Caml_option.undefined_to_opt(state.albums.baseById.get(albumId))));
  });
  const state$1 = store.getState();
  const base = state$1.albums.baseById.get(albumId);
  return $$Promise.Monad_syntax.let$star(base !== undefined ? Promise.resolve(base) : basePromise, (function (base) {
    Shared__CoverArt.preload(credentials, base.coverArt, Shared__MediaHeader.media_header_cover_art_sizes);
    const deferredAlbumInfo = Fx.runAsync(StoreFx__FetchAlbumInfo.make(albumId), {
      store: store
    }).then(function (result) {
      return Promise.resolve(Stdlib__Result.get_ok(result));
    }).then(function (param) {
      const state = store.getState();
      return Promise.resolve(Stdlib__Option.get(Caml_option.undefined_to_opt(state.albums.infoById.get(albumId))));
    });
    return Promise.resolve({
      deferredAlbumInfo: deferredAlbumInfo
    });
  }));
}

function Album$pendingComponent(Props) {
  const routeApi = ReactRouter.getRouteApi("/_layout/album/$albumId");
  const match = routeApi.useParams();
  return JsxRuntime.jsx(Pages__AlbumPage.make, {
    albumId: match.albumId
  });
}

function Album$component(Props) {
  const routeApi = ReactRouter.getRouteApi("/_layout/album/$albumId");
  const match = routeApi.useParams();
  const match$1 = routeApi.useLoaderData();
  return JsxRuntime.jsx(Pages__AlbumPage.make, {
    albumId: match.albumId,
    deferredAlbumInfo: match$1.deferredAlbumInfo
  });
}

const route = ReactRouter.createRoute({
  beforeLoad: Shared__RouterUtils.requireSubsonicCredentials,
  component: Album$component,
  getParentRoute: (function (param) {
    return Stdlib__Fun.$$const(Routes__LayoutRoute.route, param);
  }),
  loader: loader,
  path: "/album/$albumId",
  pendingComponent: Album$pendingComponent
});

const pendingComponent = Album$pendingComponent;

const component = Album$component;

export {
  loader,
  pendingComponent,
  component,
  route,
}
/* route Not a pure module */
